import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase, RentalObjectInfo, ObjectTypeInfo } from 't4core';


@Component({
  selector: 'list-item',
  templateUrl: './list-item.html',
  styleUrls: ['./list-item.css'],
    standalone: false
})
export class ListItemComponent extends ComponentBase implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
